<template>
  <div>
    <h3 class="header">KEVIN AURA </h3>
    <!-- 轮播图 -->
    <van-swipe
      class="my-swipe"
      :autoplay="8000"
      height="600"
      indicator-color="white"
    >
      <template v-for="(item, index) in banner">
        <van-swipe-item :key="index">
          <img @click="go_info(item)" :src="https + item.image" alt="" />
        </van-swipe-item>
      </template>
    </van-swipe>
    <!-- 分割语 -->
    <div>
      <p class="my_name">KEVIN AURA</p>
      <p style="font-size: 12px; color: rgb(90 89 89)">即穿即美 · 美不设限</p>
    </div>
    <!-- 最新产品推荐 -->
    <van-divider
      :style="{
        color: '#9c9e9f',
        borderColor: '#b5b3b3',
        padding: '0 16px',
        marginBottom: '30px',
        marginTop: '20px',
      }"
      >最新产品</van-divider
    >
    <div class="new_p">
      <div class="item" @click="go_info(item)" v-for="item,index in new_products" :key="index">
        <!-- 图片 -->
        <div class="image">
          <img :src="https + item.image" alt="" />
        </div>
        <!-- 名称和价格 -->
        <div class="info">
          <div class="name">{{item.title}}</div>
          <div class="price">￥{{item.price}}</div>
        </div>
        <!-- 简介 -->
        <div class="intro">
          {{ item.synopsis }}
        </div>
      </div>
    </div>
    <Tabbar></Tabbar>
  </div>
</template>

<script>
import Tabbar from "../../src/components/my_tabbar.vue";
import { home } from "../../src/utils/request";
import axios from "axios";

export default {
  name:'Home',
  data() {
    return {
      banner: [],
      new_products: [],
      https: "",
    };
  },
  async mounted() {
    this.https = axios.defaults.baseURL; //获取axios的baseURL
    //发送网路请求
    const res = await home();
    //设置banner数据
    this.banner = res.data.data.banner;
    //设置推荐数据
    this.new_products = res.data.data.new_products;
  },
  methods:{
    go_info(item) {
      this.$router.push({
        path:"/shop_info",
        query:{
          goods_id:item.id
        }
      });
    },
  },
  components: {
    Tabbar,
  },
};
</script>

<style scoped>
.my-swipe {
  box-sizing: border-box;
}
.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  line-height: 150px;
  text-align: center;
  overflow: hidden;
}
.van-swipe-item img {
  width: 93%;
  height: 100%;
  margin: 0 auto;
  object-fit: cover;
  display: block;
}

.van-swipe__indicator {
  width: 12px !important;
  height: 12px !important;
}

.my_name {
  font-size: 30px;
  font-weight: 700;
  font-family: "宋体";
  margin-bottom: 12px;
}
p {
  font-family: "宋体";
  margin-bottom: 8px;
}
.new_p {
  padding: 0 14px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.info {
  display: flex;
  justify-content: space-between;
  padding: 6px 4px;
  padding-bottom: 0px;
}

.info .name {
  width:85%;
  text-align: left;
  white-space: nowrap;      /* 禁止换行 */
  overflow: hidden;        /* 隐藏溢出内容 */
  text-overflow: ellipsis; /* 显示省略号 */
  font-size: 12px;
}
.price {
  font-weight: 700;
  font-size: 15px;
}

.item {
  width: 47%;
  margin-bottom: 14px;
}

.intro {
  text-align: left;
  color: #909090;
  font-size: 10px;
  line-height: 16px;
  padding: 0px 4px;
}
.image {
  width: 163px;
  height: 196px;
  background: pink;
}
.header {
  font-family: "宋体";
}
</style>